import React from "react";
import { SEO } from "@fishrmn/fishrmn-components";
import { socialMediaTypes } from "@fishrmn/fishrmn-types";

import config from "../../config/config";
import EventsForm from "../components/EventsForm/index";

export default () => (
  <div id="events">
    <SEO
      config={config}
      path={config.baseConfig.pageMetadata.events.path}
      title={config.baseConfig.pageMetadata.events.title}
      description={config.baseConfig.pageMetadata.events.description}
      smTypes={[socialMediaTypes.facebook, socialMediaTypes.twitter]}
    />
    <div id="events-hero">
      <div>EVENTS</div>
    </div>
    <div id="events-copy">
      <div>
        Bring Whole Sol to you! <br /> Book us for private events.
      </div>
    </div>
    <div id="events-form">
      <EventsForm />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/events.jsx